import p from "./ghl-ui.es1589.js";
import f from "./ghl-ui.es1590.js";
import a from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import l from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { numericPatterns as T } from "./ghl-ui.es1672.js";
import { parseNDigits as v, parseNumericPattern as P } from "./ghl-ui.es1671.js";
var k = /* @__PURE__ */ function(u) {
  c(i, u);
  var s = l(i);
  function i() {
    var o;
    p(this, i);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return o = s.call.apply(s, [this].concat(e)), n(a(o), "priority", 70), n(a(o), "incompatibleTokens", ["h", "H", "k", "t", "T"]), o;
  }
  return f(i, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "K":
          return P(T.hour11h, r);
        case "Ko":
          return t.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return v(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 0 && e <= 11;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      var m = r.getUTCHours() >= 12;
      return m && t < 12 ? r.setUTCHours(t + 12, 0, 0, 0) : r.setUTCHours(t, 0, 0, 0), r;
    }
  }]), i;
}(h);
export {
  k as Hour0To11Parser
};
